import { render, staticRenderFns } from "./LayoutHub.vue?vue&type=template&id=3d68f0ce&"
import script from "./LayoutHub.vue?vue&type=script&lang=js&"
export * from "./LayoutHub.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHub.vue?vue&type=style&index=0&id=3d68f0ce&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports